import { render, staticRenderFns } from "./contract-record-detail-page.vue?vue&type=template&id=7bfd371f&scoped=true&"
import script from "./contract-record-detail-page.vue?vue&type=script&lang=js&"
export * from "./contract-record-detail-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bfd371f",
  null
  
)

export default component.exports